import zhTW from "antd/es/locale/zh_TW";

const customLocale = {
  ...zhTW,
  Pagination: {
    ...zhTW.Pagination,
    items_per_page: "筆/頁"
  }
};

export default customLocale;
